/**
 * Chaves conhecidas retornadas pelo endpoint `v2/tags` (UserTagService).
 */
export enum UserTagKey {
  IMPORTED_CHANNEL = 'imported_channel',
  REGISTRATION_CHANNEL = 'registration_channel',
  CAMPAIGN = 'campaign',
}

/**
 * Valores de tag que identificam um cliente originado/tombado do Santander.
 */
export enum SantanderTagValue {
  IMPORTED_CHANNEL = 'santander027',
  REGISTRATION_CHANNEL = 'simplificadosantander',
  CAMPAIGN = 'santanderprivate',
}
